import React from 'react';
import { useTranslation } from 'react-i18next';
import style from './styles.module.scss';

const keyI18n = 'translations.virtualDesk.empty';

export function EmptyList() {
  const { t } = useTranslation();

  return (
    <div className={style.emptyListContainer}>
      <p>{t(`${keyI18n}.description`)}</p>

      <span><strong>{t(`${keyI18n}.serviceHours`)}</strong></span>
      <span>{t(`${keyI18n}.weekdays`)}</span>
      <span>{t(`${keyI18n}.hours`)}</span>
    </div>
  );
}
